export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-6 md:mb-8">
            Votre réparateur de fenêtre à Obernai
          </h2>
          <div className="space-y-5 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              Obernai, perle du vignoble, attire chaque année des milliers de visiteurs. Derrière les façades à colombages et les rues pavées, les fenêtres en bois ancien demandent un savoir-faire spécifique. Nous réparons aussi les menuiseries modernes des quartiers périphériques, pièce comprise.
            </p>
            <p>
              Obernai, perle du vignoble, est célèbre pour son centre historique préservé. Les maisons à colombages et les rues pavées abritent des fenêtres en bois traditionnelles qui demandent un savoir-faire spécifique. Les quartiers périphériques, eux, comptent des résidences récentes avec des menuiseries modernes. Nous connaissons les deux.
            </p>
            <p>
              Notre atelier de Strasbourg est à une demi-heure d'Obernai. Le déplacement est gratuit, le diagnostic est gratuit, la pièce de remplacement est comprise et chaque réparation est garantie 10 ans. Nos techniciens connaissent les spécificités des fenêtres anciennes alsaciennes et des menuiseries modernes.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}